"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "listScrollParents", {
    enumerable: true,
    get: function() {
        return listScrollParents;
    }
});
const _getScrollParent = require("./getScrollParent");
function listScrollParents(node) {
    const scrollParents = [];
    let cur = node;
    while(cur){
        const scrollParent = (0, _getScrollParent.getScrollParent)(cur);
        if (node.ownerDocument.body === scrollParent) {
            scrollParents.push(scrollParent);
            break;
        }
        scrollParents.push(scrollParent);
        cur = scrollParent;
    }
    return scrollParents;
}
